<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="acknowledgement">
<h1>Acknowledgement</h1>
<p style="text-indent:0em !important;">Thank you to all the trainers and my fellow members at F45 SURFERS PARADISE for helping me regain my self-confidence and writing mojo.</p><br/>
<p style="text-indent:0em !important;">Special thanks to my good friend Maria Trujillo for some character inspiration and sharing some of her wonderful Colombian phrases.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch004.vue?f1f2af0e